export const isRequired = (fieldName: any) => `O campo ${fieldName} é obrigatório`;

export const mustMatch = (otherFieldName: any) => {
  return (fieldName: any) => `O campo ${fieldName} deve igual ao campo ${otherFieldName}`;
};

export const maxLength = (length: any) => {
  return (fieldName: any) => `O campo ${fieldName} deve ter no máximo ${length} caracteres`;
};

export const minLength = (length: any) => {
  return (fieldName: any) => `O campo ${fieldName} deve ter pelo menos ${length} caracteres`;
};

export const arrayMinLength = (length: any) => {
  return (fieldName: any) => `O campo ${fieldName} deve ter pelo menos ${length} item(s)`;
};
export const arrayMaxLength = (length: any) => {
  return (fieldName: any) => `O campo ${fieldName} deve ter no máximo ${length} item(s)`;
};
export const isEmail = () => {
  return (fieldName: any) => `O campo ${fieldName} não é um email válido`;
};
export const isUrl = () => {
  return (fieldName: any) => `O campo ${fieldName} não é uma url válida`;
};
export const isSunUrl = () => {
  return (fieldName: any) => `O campo ${fieldName} não pode ser um link direto para o checkout`;
};
export const minimun = (min: any) => {
  return (fieldName: any) => `O valor de ${fieldName} tem que ser no mínimo ${min}`;
};

export const maximum = (max: any) => {
  return (fieldName: any) => `O valor de ${fieldName} tem que ser no máximo ${max}`;
};

export const lunhCheck = () => {
  return (fieldName: any) => `O ${fieldName} informado não é válido`;
};
